import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6014c952")

_pushScopeId("data-v-6014c952")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Presenze")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = {
  key: 0,
  class: "modal_straordinario"
}
const _hoisted_5 = { class: "input_container" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "title_qr" }, "Inquadra il codice QR per timbrare", -1)
const _hoisted_7 = { class: "qr_code" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "frame" }, null, -1)
const _hoisted_9 = { class: "confirmation_text" }
const _hoisted_10 = {
  key: 0,
  class: "modal_straordinario"
}
const _hoisted_11 = { class: "input_container" }
const _hoisted_12 = {
  key: 0,
  class: "field"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Straordinario effettuato", -1)
const _hoisted_14 = { class: "field" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Note", -1)
const _hoisted_16 = { class: "timer_clock" }
const _hoisted_17 = { class: "today_date" }
const _hoisted_18 = {
  key: 0,
  class: "buttons_container_presenza"
}
const _hoisted_19 = {
  key: 0,
  class: "selezione_reparto"
}
const _hoisted_20 = { class: "btn_presenze_container ion-padding-horizontal" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", null, "Timbra entrata", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("span", null, "Timbra uscita", -1)
const _hoisted_23 = {
  key: 1,
  class: "btn_presenza_container ion-padding-horizontal"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("span", null, "Inserisci presenza", -1)
const _hoisted_25 = {
  key: 2,
  class: "ion-padding-horizontal ion-margin-bottom"
}
const _hoisted_26 = {
  key: 3,
  class: "ion-padding-horizontal ion-margin-bottom"
}
const _hoisted_27 = {
  key: 4,
  class: "no_presenze_container"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "no_presenze" }, "Nessuna presenza inserita", -1)
const _hoisted_29 = { key: 5 }
const _hoisted_30 = { class: "container_presenze" }
const _hoisted_31 = { class: "presenza_info" }
const _hoisted_32 = { class: "title" }
const _hoisted_33 = { class: "orari" }
const _hoisted_34 = {
  key: 0,
  class: "straordinario"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_qr_stream = _resolveComponent("qr-stream")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_textarea = _resolveComponent("ion-textarea")
  const _component_ion_select_option = _resolveComponent("ion-select-option")
  const _component_ion_select = _resolveComponent("ion-select")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start",
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadTimbrature()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        ionScroll: "scrollFunction($event)"
      }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode(_Transition, { name: "fade-transition" }, {
                  default: _withId(() => [
                    ($setup.showQrCode)
                      ? (_openBlock(), _createBlock("div", _hoisted_4, [
                          _createVNode("div", _hoisted_5, [
                            _hoisted_6,
                            _createVNode("div", _hoisted_7, [
                              _createVNode(_component_qr_stream, {
                                onDecode: $setup.onDecode,
                                class: "mb"
                              }, {
                                default: _withId(() => [
                                  _hoisted_8
                                ]),
                                _: 1
                              }, 8, ["onDecode"])
                            ]),
                            _createVNode("div", _hoisted_9, _toDisplayString($setup.confirmationText), 1),
                            _createVNode("button", {
                              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.handleQrCodeTimbratura())),
                              class: "btn_salva_straordinario",
                              disabled: $setup.disabledQrCodeButton
                            }, "Salva", 8, ["disabled"]),
                            _createVNode("button", {
                              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.chiudiQrCode())),
                              class: "btn_chiudi_straordinario"
                            }, "Chiudi")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_Transition, { name: "fade-transition" }, {
                  default: _withId(() => [
                    ($setup.showStraordinario)
                      ? (_openBlock(), _createBlock("div", _hoisted_10, [
                          _createVNode("div", _hoisted_11, [
                            ($setup.dipendenteSettings.dipendenti_consenti_straordinari === '1')
                              ? (_openBlock(), _createBlock("div", _hoisted_12, [
                                  _hoisted_13,
                                  _createVNode(_component_ion_input, {
                                    modelValue: $setup.selectedPresenza.presenze_straordinario,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ($setup.selectedPresenza.presenze_straordinario = $event)),
                                    type: "number"
                                  }, null, 8, ["modelValue"])
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("div", _hoisted_14, [
                              _hoisted_15,
                              _createVNode(_component_ion_textarea, {
                                modelValue: $setup.selectedPresenza.presenze_note,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ($setup.selectedPresenza.presenze_note = $event)),
                                rows: "4",
                                placeholder: "Informazioni presenza..."
                              }, null, 8, ["modelValue"])
                            ]),
                            _createVNode("div", {
                              onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.editPresenza())),
                              class: "btn_salva_straordinario"
                            }, "Salva"),
                            _createVNode("div", {
                              onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.chiudiStraordinario())),
                              class: "btn_chiudi_straordinario"
                            }, "Chiudi")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode("div", _hoisted_16, _toDisplayString($setup.time), 1),
                _createVNode("div", _hoisted_17, _toDisplayString($setup.todayDate), 1),
                ($setup.dipendenteSettings.dipendenti_timbra_posteriori === '0')
                  ? (_openBlock(), _createBlock("div", _hoisted_18, [
                      ($setup.dipendenteSettings.dipendenti_dichiara_reparto === '1')
                        ? (_openBlock(), _createBlock("div", _hoisted_19, [
                            _createVNode(_component_ion_select, {
                              name: "tipologia",
                              interface: "action-sheet",
                              "cancel-text": "Annulla",
                              "ok-text": "Conferma",
                              modelValue: $setup.repartoSelezionato,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ($setup.repartoSelezionato = $event)),
                              value: "1",
                              placeholder: "Seleziona il reparto in cui timbrare",
                              onIonChange: _cache[10] || (_cache[10] = ($event: any) => ($setup.setReparto($event.target.value)))
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.reparti, (reparto) => {
                                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                                    key: reparto.reparti_id,
                                    value: reparto.reparti_id
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(reparto.reparti_nome), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_20, [
                        _createVNode("button", {
                          class: "btn_timbratura",
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.handleTimbraEntrata && $setup.handleTimbraEntrata(...args))),
                          disabled: $setup.entrataTimbrata
                        }, [
                          _createVNode(_component_ion_icon, {
                            icon: $setup.arrowForward,
                            slot: "end"
                          }, null, 8, ["icon"]),
                          _hoisted_21
                        ], 8, ["disabled"]),
                        _createVNode("button", {
                          class: "btn_timbratura",
                          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => ($setup.handleTimbraUscita && $setup.handleTimbraUscita(...args))),
                          disabled: $setup.uscitaTimbrata
                        }, [
                          _createVNode(_component_ion_icon, {
                            icon: $setup.arrowBack,
                            slot: "end"
                          }, null, 8, ["icon"]),
                          _hoisted_22
                        ], 8, ["disabled"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ($setup.dipendenteSettings.dipendenti_timbra_posteriori === '1')
                  ? (_openBlock(), _createBlock("div", _hoisted_23, [
                      _createVNode("button", {
                        class: "btn_presenza",
                        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => ($setup.createPresenza && $setup.createPresenza(...args)))
                      }, [
                        _hoisted_24
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ($setup.dipendenteSettings.dipendenti_timbra_qrcode === '1')
                  ? (_openBlock(), _createBlock("div", _hoisted_25, [
                      _createVNode("div", {
                        class: "btn_reperibilita",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.openQrCode()))
                      }, " Timbra con Codice QR ")
                    ]))
                  : _createCommentVNode("", true),
                ($setup.dipendenteSettings.dipendenti_reperibilita === '1')
                  ? (_openBlock(), _createBlock("div", _hoisted_26, [
                      _createVNode("div", {
                        class: "btn_reperibilita",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.openReperibilita()))
                      }, " Dichiara reperibilità ")
                    ]))
                  : _createCommentVNode("", true),
                (!$setup.presenze.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_27, [
                      _hoisted_28
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_29, [
                      _createVNode("div", _hoisted_30, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.presenze, (timbratura) => {
                          return (_openBlock(), _createBlock("div", {
                            key: timbratura.presenze_id,
                            class: "presenza",
                            onClick: ($event: any) => ($setup.apriStraordinario(timbratura))
                          }, [
                            _createVNode("div", _hoisted_31, [
                              _createVNode("div", _hoisted_32, _toDisplayString($setup.dateFormat(timbratura.presenze_data_inizio)) + " " + _toDisplayString($setup.printCustomer(timbratura)), 1),
                              _createVNode("div", _hoisted_33, " Ingresso: " + _toDisplayString(timbratura.presenze_ora_inizio) + " - Uscita: " + _toDisplayString(timbratura.presenze_ora_fine || "-"), 1),
                              (timbratura.presenze_straordinario > 0)
                                ? (_openBlock(), _createBlock("div", _hoisted_34, " Straordinario: " + _toDisplayString(parseFloat(timbratura.presenze_straordinario).toFixed(2)), 1))
                                : _createCommentVNode("", true)
                            ])
                          ], 8, ["onClick"]))
                        }), 128))
                      ])
                    ]))
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})